import { axiosInstance } from "../../utils";

const actions = {
  FETCH_ACCOUNTING_REQUESTED: "FETCH_ACCOUNTING_REQUESTED",
  FETCH_ACCOUNTING_SUCCEEDED: "FETCH_ACCOUNTING_SUCCEEDED",
  FETCH_ACCOUNTING_FAILED: "FETCH_ACCOUNTING_FAILED",

  fetchAccounting: (params = undefined) => {
    return {
      type: actions.FETCH_ACCOUNTING_REQUESTED,
      payload: params,
    };
  },

  getAccounting: async (params = undefined) => {
    const url = `transactions`;

    try {
      const transactions = await axiosInstance.get(url, { params });

      return transactions?.data;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
